export default __webpack_public_path__ + "static/media/maps-and-flags.df6b4183.svg";